<template lang='pug'>
v-layout(wrap, flex, align-center)
  v-flex.px-1(xs9 md6 text-xs-center align-content-center)
    v-card.py-0(flat color='grey lighten-4 ' v-for='(reactivo, index) in this.currentStep.question.reactivos ' :key='index ')
      v-layout.my-2.text-xs-right(flat)
        v-flex.py-0.my-0(xs11)
          v-card-text.pregunta1.pa-0.pa-sm-3.text-xs-left.text-center
            | {{reactivo.pregunta}}
        v-flex.py-3.mr-4.ml-0(xs1 text-xs-start)
          v-icon(size='15px' v-if=' (reactivo.resultado==0) ' color='red ') fas fa-times
          v-icon(size='15px' v-if=' (reactivo.resultado==1) ' color='green ') fas fa-check
  v-flex.px-1(xs3 md3 text-xs-center)
    v-card.py-1(flat v-for='(reactivo, index) in this.currentStep.question.reactivos ' :key='index ')
      .selectorBox(v-dragula='reactivo.respuesta ' drake='first ')
        v-card-text.reactivo.text-center.text-uppercase.align-middle.pa-2.d-flex.justify-center.align-center(v-for='r in reactivo.respuesta' :key='r' style="touch-action: none;")
          span {{r}}
  v-flex.px-1(md3 text-xs-center)
    div(v-dragula='this.currentStep.question.respuestas' drake='first ')
      v-card.py-1(flat style='cursor: pointer; touch-action: none;' v-for='respuesta in this.currentStep.question.respuestas ' :key='respuesta ')
        .selectorBox
          v-card-text.reactivo.text-center.text-uppercase.align-middle.pa-3.d-flex.justify-center.align-center
            | {{respuesta}} 
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DragandDropMatch',
  computed: {
    ...mapGetters(['currentStep'])
  }, 
  methods:{
  },
  created() {
      let env = this;
      let service = this.$dragula.$service;

      service.eventBus.$on('drop', function (args) {
        let answeredcounter = 0;

        for(let i=0;i <env.currentStep.question.reactivos.length;i+=1){
            if(env.currentStep.question.reactivos[i].respuesta.length>0){
               answeredcounter ++;
            }
        }

        if(env.currentStep.question.reactivos.length === (answeredcounter+1)){
            env.currentStep.answered = true;    
        }
      });

      service.eventBus.$on('dragend', function (args) {
        env.currentStep.question.reactivos.filter(o => o.type === 'answer-place' && o.respuesta.length > 1).forEach(element => {            
            env.currentStep.question.respuestas.push(element.respuesta.splice(1,1)[0]);
        });
      });

  },
}

</script>

<style scoped>
@import 'draganddrop-match.scss';
</style>